"use client";

import Link from "next/link";

import { useCurrentLocale, useI18n } from "@/locales/client";
export default function ProductsMega() {
  const t = useI18n();
  const locale = useCurrentLocale();
  const withLocale = (href: string) => {
    if (!href.startsWith("/")) return href;
    if (href === "/") return `/${locale}`;
    if (href === `/${locale}` || href.startsWith(`/${locale}/`)) return href;
    return `/${locale}${href}`;
  };
  const SAFETY_RISKS = [
    { label: t("ppe-non-compliance"), href: "/products/safety-risks/ppe-non-compliance" },
    { label: t("vehicle-pedestrian-near-misses"), href: "/products/safety-risks/vehicle-pedestrian-collision" },
    { label: t("restricted-area-monitoring"), href: "/products/safety-risks/restricted-area-monitoring" },
    { label: t("ergonomics"), href: "/products/safety-risks/ergonomics" },
    { label: t("industrial-fire"), href: "/products/safety-risks/industrial-fire" },
    { label: t("slip-and-fall-menu"), href: "/products/safety-risks/slip-and-fall" },
  ];
  return (
    <div className="bg-[#212121] text-white py-4 px-6">
      <div className="flex gap-8">
        <div className="flex flex-col gap-2 min-w-[250px]">
          <div className="text-[16px] font-light font-poppins py-2 block cursor-default">{t("safety-risks-we-detect")}</div>
          <ul className="ml-4 space-y-2 text-[14px] font-normal font-poppins text-white/90">
            {SAFETY_RISKS.map((r) => (
              <li key={r.href} className="flex items-start gap-2">
                <span className="text-[#FF8B49] mt-1">•</span>
                <Link href={withLocale(r.href)} prefetch={false} className="block transition-colors hover:text-[#FF8B49] py-1">
                  {r.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div className="w-px bg-[#FF8B49] self-stretch" aria-hidden="true" />

        <div className="flex flex-col gap-3 min-w-[200px]">
          {[
            { title: t("product-overview"), href: "/products/overview" },
            { title: t("ai-edge-system"), href: "/products/edge-ai" },
            { title: t("chatbot"), href: "/chatbot" },
            { title: t("reporting"), href: "/products/reporting" },
            { title: t("privacy"), href: "/products/privacy" },
            { title: t("integrations"), href: "/products/integrations" },
          ].map((c) => (
            <div key={c.title}>
              <Link
                href={withLocale(c.href)}
                prefetch={false}
                className="text-[16px] font-light font-poppins transition-colors hover:text-[#FF8B49] py-2 block"
              >
                {c.title}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
